(function($) {

	$.fn.galleryThumbs = function() {
		var elem = $(this),
			body = $('body'),
			triggers = elem.find('.js-gallery-thumbs__trigger'),
			target = elem.find('.js-gallery-thumbs__target'),
			settings = {
				activeClass: 'is-active',
				fullscreenClass: 'is-fullscreen',
				sourceAttribute: 'data-gallery-source',
				loadingLabel: 'Please wait, the gallery is loading',
				loadingHtml: '<div class="[ full-screen-loader ] [ js-gallery-thumbs__loader ]" aria-hidden="true" role="presentation"></div>',
				loaderSelector: '.js-gallery-thumbs__loader'
			};

		var init = function() {

			triggers.on('click', function(evt) {

				var trigger = $(this);

				// If there's a gallery source 
				if(trigger.attr(settings.sourceAttribute)) {

					// Prevent the clickthrough
					evt.preventDefault();

					// Set an aria label
					trigger.attr('aria-label', settings.loadingLabel);

					// Set the loader
					target.html(settings.loadingHtml);

					// Add the fullscreen class to the body
					body.addClass(settings.fullscreenClass);

					// Set a timeout to allow loader to render
					setTimeout(function() {

						// Show the loader
						target.find(settings.loaderSelector).addClass(settings.activeClass);

						// Load the content from the source
						$.ajaxHtml(trigger.attr(settings.sourceAttribute), function(data) {

							// Set a natural timeout, so the click -> load -> show doesn't feel janky
							setTimeout(function() {

								// Hide the loader
								target.find(settings.loaderSelector).removeClass(settings.activeClass);

								setTimeout(function() {

									// Set the content
									target.html(data);

									// Remove aria label attr
									trigger.removeAttr('aria-label');

									// Bind the gallery module
									setTimeout(function() {

										// Remove the fullscreen class from the body
										body.removeClass(settings.fullscreenClass);
										
										// Show the gallery
										target.find('[data-module="gallery"]')
												.gallery()
												.addClass(settings.activeClass);
									}, 50);
									
								}, 200);

							}, 300);

						});

					}, 50);

				}
			});

		};

		init();
		return this;
	};

}($));